export default {"src":"/_next/static/media/lead-mission.8f452940.svg","height":196,"width":1112};